// src/services/auth.js
import api from './api';

export const authAPI = {
  login: (credentials) => {
    return api.post('/token/', credentials)
      .then(res => res.data)
      .catch(err => {
        console.error("Login error:", err.response?.data || err.message);
        throw err;
      });
  },

  verifyToken: (token) => {
    return api.post('/token/verify/', { token })
      .then(res => res.data)
      .catch(err => {
        console.error("Token inválido ❌:", err.response?.data || err.message);
        throw err;
      });
  },

  refreshToken: (refresh) => {
    return api.post('/token/refresh/', { refresh })
      .then(res => res.data)
      .catch(err => {
        console.error("Error refrescando token:", err.response?.data || err.message);
        throw err;
      });
  },
};


export default authAPI;